import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { FC } from "react";
import Image from "next/image";

export const DeleteTouristModal: FC<any> = ({
  isOpen,
  onClose,
  onCancel,
  onAccept,
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Stack className="flex w-full max-w-[524px] flex-col items-center gap-6 rounded-xl bg-white p-6 shadow-xl center-modal max-md:animate-up-modal max-md:bottom-modal">
        <Box>
          <Image
            width={80}
            height={80}
            src={"/images/warning_sign.png"}
            alt="Попередження!"
          />
        </Box>
        <Typography
          component={"h4"}
          className="text-lg font-semibold text-dark-gray"
        >
          Видалити туриста?
        </Typography>
        <Typography
          component={"h4"}
          className="text-[15px] font-normal text-dark-gray text-center"
        >
          Шановний клієнте, ви дійсно бажаєте видалити даного туриста зі списку
          застрахованих?
        </Typography>
        <Stack className="flex-center-row w-full gap-3">
          <Button onClick={onCancel} variant="outlined" className="w-full" size='large'>
            Ні
          </Button>
          <Button onClick={onAccept} variant="contained" className="w-full" size='large'>
            Так
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
